import type { IVariable } from '@carboncopyco/types';
import { isImageVariable, isTextVariable } from '@carboncopyco/utils';
import { ImageVariableInput } from './ImageVariableInput';
import { TextVariableInput } from './TextVariableInput';

export interface VariableInputProps {
  variable: IVariable;
  readOnly?: boolean;
  name: string;
}

export const VariableInput = ({
  variable,
  readOnly,
  name,
}: VariableInputProps) => {
  const props = {
    readOnly,
    name,
  };

  if (isTextVariable(variable)) {
    return <TextVariableInput {...props} />;
  }

  if (isImageVariable(variable)) {
    return <ImageVariableInput {...props} />;
  }

  return null;
};
